let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("feCKC")).then(() => parcelRequire('bfN0N'));